module.exports = {
  requests: ($stateParams, Api) ->
    return Api.ResearchRequest.query().$promise

  staff: (Api) ->
    return Api.Users.query(is_staff:true).$promise
}
